import { Location, LocationPlan } from '@chegg-wt/core/types/upgrade'

export const LocationBasedPlan: LocationPlan = {
  [Location.US]: { itemId: 'CHGMnthCTFMNFT', price: '$9.99' },
  [Location.AU]: { itemId: 'CHGMnthCTFMNFTAUD', price: '$12.99' },
  [Location.GB]: { itemId: 'CHGMnthCTFMNFTGBP', price: '£6.99' },
}
